import React from 'react';
import omit from 'lodash/omit';
import prettyBytes from 'pretty-bytes';
import mimer from 'mimer';

import { toMimes } from '../helpers';
import ModalAlert from './ModalAlert.jsx';

window.mimer = mimer;

const ModalFileAlert = (props) => {
  const { accept, maxSize, show } = props;

  return (
    <ModalAlert
      show={Boolean(show)}
      {...omit(props, ['accept', 'maxSize', 'show'])}
    >
      <>
        {show === 'maxSize' && (
          <>
            Your file exceeds the max file size:
            &nbsp;
            {prettyBytes(maxSize)}
          </>
        )}
        {show === 'accept' && (
          <>
            Only accepts file types:
            <br />
            {toMimes(accept).join(', ')}
          </>
        )}
      </>
    </ModalAlert>
  );
};

export default ModalFileAlert;
